import { MunicipioService } from './../../../_core/services/municipios.service';
import  Swal  from 'sweetalert2';
import { Localizacao, uf } from './../../../_core/models/localizacao';
import { LocalizacaoService } from './../../../_core/services/localizacao.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-localizacao-bens-modal',
  templateUrl: './localizacao-bens-modal.component.html',
  styleUrls: ['./localizacao-bens-modal.component.scss']
})
export class LocalizacaoBensModalComponent implements OnInit {
  @Input() public cD_BPM_NR_UNIDADE!: number;
  title = 'Unidade Operacional';
  form: FormGroup;
  localizacao: Localizacao;
  loading = true;

  ufOrigem:any[];
  municipiosOrigem:any[];
  arrayUf:uf[];
  
  constructor( 
    private localizacaoService:LocalizacaoService,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    public modalService: NgbModal,
    private municipio : MunicipioService,
    ) { 
      this.localizacao = new Localizacao();
    }

  ngOnInit(): void {
    this.localizacao = new Localizacao();
    this.gerarForm(this.localizacao);
    this.loading = false;
    this.carregaLocalizacao();
    this.getUfOrigem();
    //this.form.valueChanges.subscribe((element) => console.log(element)); 
  }

  selectMun(item: any){
    //console.log(item);
  };

  getUfOrigem(){
    this.municipio.getUf().subscribe(
    (success)=>{
      this.arrayUf = success;
      var array =this.arrayUf.map((C)=>C.sigla)
      this.ufOrigem =array.sort();
      this.getMunicipioOrigem();
    }
  )
}

  getMunicipioOrigem(){
      this.municipio.getMunicipios(this.form.controls.dS_BPM_UF_UNIDADE?.value).subscribe(
        (success)=>{
          this.municipiosOrigem = success;
          var array =this.municipiosOrigem.map((C)=>C.nome)
          this.municipiosOrigem =array.sort();
        }
      )
  }

  gerarForm(localizacao:Localizacao){
    this.form = this.fb.group({
      // cD_BPM_NR_UNIDADE:[localizacao.cD_BPM_NR_UNIDADE,[Validators.required]],
      dS_BPM_UNIDADE:[localizacao.dS_BPM_UNIDADE],
      dS_BPM_UF_UNIDADE:[localizacao.dS_BPM_UF_UNIDADE],
      dS_BPM_MUNICIPIO_UNIDADE:[localizacao.dS_BPM_MUNICIPIO_UNIDADE],
      dS_BPM_ENDERECO_UNIDADE:[localizacao.dS_BPM_ENDERECO_UNIDADE],
      fL_BPM_ATIVO:[localizacao.fL_BPM_ATIVO,[]],
      fL_BPM_DELETADO:[0,[]]
    })
  }
  carregaLocalizacao(): void{
    if (this.cD_BPM_NR_UNIDADE != 0) {
      this.localizacaoService.localizacaoById(this.cD_BPM_NR_UNIDADE).subscribe((localizacao) => {
        this.localizacao = localizacao;
        this.gerarForm(this.localizacao);
      });
    }
  }
  submit(){
    this.loading = true;
    var localizacao:Localizacao = this.form.value;
    localizacao.fL_BPM_ATIVO = Number(this.form.controls['fL_BPM_ATIVO'].value)
    if(this.form.invalid){
      Swal.fire('Alerta','Olá digite os campos corretamente','warning');
      this.activeModal.close();
      return;
    } else if (this.cD_BPM_NR_UNIDADE == 0) {
      this.localizacaoService.insert(localizacao).subscribe((data) => {
        Swal.fire(
          'Adicionado!',
          'Localização adicionado com sucesso!',
          'success'
        ).then(() => {
          
          this.loading = false;
          this.activeModal.close();
        });
      },
      (err) =>{
        this.loading = false;
        
      });
    } else {
      this.localizacaoService
      .update(this.cD_BPM_NR_UNIDADE,localizacao)
      .subscribe(
        data => {
        Swal.fire(
          'Atualizado!',
          'Localização atualizado com sucesso!',
          'success'
        ).then(() => {
          this.loading = false;
          this.activeModal.close();
        });
      });
    }
  }
}
